import { Breadcrumb, Input, message, Select, Tabs, Timeline } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ActiveDotIcon,
  BackIcon,
  CloseIcon,
  InactiveDotIcon,
} from "../../../asset";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import style from "./DepotConfigAdd.module.css";
import axios from "axios";
import { ROUTES } from "../../../constant/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import MapsSmall from "../../../component/maps/MapsSmall";
import Delete from "../../../component/modal/ModalDelete";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import { useSelector } from "react-redux";
import ModalMaps from "../../../component/modal/ModalMaps";
import moment from "moment";
import dayjs from "dayjs";
import Accordion from "../../../component/accordion/Accordion";
import { LabelDetail, ValueDetail } from "../../../component/page-components/detail";
import OperationalDate from "../company-profile/operational-date";
import CustomDivider from "../../../component/divider/CustomDivider";

const DepotConfigDetail = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [isOpenMaps, setIsOpenMaps] = useState(false);
  const [index, setIndex] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [opsDate, setOpsDate] = useState([])
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [operationalDateData, setOperationalDateData] = useState([]);
  const [updatedOperationalDate, setUpdatedOperationalDate] = useState([]);
  

  const [managementHistoryList, setManagementHistoryList] = useState([]);

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return moment(timestamp).utc().format("HH:mm");
  };

  useEffect(() => {
    fetchData();
    getManagementHistoryList();
  }, []);
  const api = GROLOG_URL;

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetBaseUrl = async (
    endpoint,
    tkn,
    params,
    dispatch,
    refresh_token
  ) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(
      `audit/v1/grolog/audit?page=1&filter=table_name eq depot, primary_key eq ${location.state}`
    );

    const data = res?.data?.payload;
    const reorderedData = [];

    for (let i = data.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element);
    }

    setManagementHistoryList(reorderedData);
  };

  const fetchData = async () => {
    let res = await doGet(
      `/depot-configuration/${location.state}?${param}`,
      token
    );
    setDetail(res?.data?.payload?.data);
    let opsDates=[]
    for (let i = 0; i < res?.data?.payload?.data?.operational_date?.length; i++) {
      const element = res?.data?.payload?.data?.operational_date[i];
      let datas = {
        ...element,
        date_start_code :"M"+moment(element?.date_start).format("MM"),
      date_end_code :"M"+moment(element?.date_end).format("MM"),
      
      };
      opsDates.push(datas);
    }
    setOpsDate(opsDates)
  };

  const toMapsFull = (el) => {
    navigate(ROUTES.DEPOT_CONFIG.MAPS, { state: el });
  };

  const DepotProfile = () => {
    return (
      <>
        <ModalMaps
          show={isOpenMaps}
          address={detail?.depot_profile?.depot_address_1}
          latitude={detail?.depot_profile?.depot_latitude}
          longitude={detail?.depot_profile?.depot_longitude}
          onClose={() => setIsOpenMaps(false)}
        />
        <div className="flex flex-col gap-[40px]">
          {/* depot info */}
          <div>
            {/* <h3 className="font-roboto font-medium text-lg mb-6 mt-[30px]">
              {t("Depot Information")}
            </h3> */}
        <CustomDivider name={"Depot Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot ID")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_id}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Email")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_email}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Name")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_name}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Phone")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_phone}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Description")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_description}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Fax")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_fax}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          {/* depot address */}
          <div>
            {/* <h3 className="font-roboto font-medium text-lg mb-10 mt-[30px]">
              {t("Depot Address")}
            </h3> */}
        <CustomDivider name={"Depot Address"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Country")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_country}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot District")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_district}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Address")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_address_1}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Neighbourhood")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_neighborhood}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Longitude")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_longitude}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Island")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_island}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Sub District")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_sub_district}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Address 2")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_address_2}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Hamlet")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_hamlet}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Latitude")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_latitude}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Province")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_province}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Urban Village")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_urban_village}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Address 3")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_address_3}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Depot Postal Code")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.depot_profile?.depot_postal_code}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("CUSTOMER:PINPOIN")}
                  </label>
                  {/* <div className="w-[500px] h-20 "> */}
                  <MapsSmall
                    long={detail?.depot_profile?.depot_longitude}
                    lat={detail?.depot_profile?.depot_latitude}
                    onClicks={() => setIsOpenMaps(true)}
                  />
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const SystemPreference = () => {
    return (
      <>
        <div className="flex flex-col gap-[40px]">
          {/* depot info */}
          <div>
            {/* <h3 className="font-roboto font-medium text-lg mb-6 mt-[30px]">
              {t("Depot Information")}
            </h3> */}
        <CustomDivider name={"Depot Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Length")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.system_preferences?.length_uom}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Temperature")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.system_preferences?.temperature_uom}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Weight")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.system_preferences?.weight_uom}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Max Range")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.system_preferences?.max_range}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Volume")}
                  </label>
                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                    {detail?.system_preferences?.volume_uom}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const clickCard = (i, open) => {
    setIndex(i);
    setIsOpen(isOpen ? false : true);
  };

  const PersonInCharge = () => {
    return (
      <>
        {detail?.person_in_charge?.map((el, i) => {
          return (
            <div id={i}>
              <Accordion
                onClick={() => clickCard(i, isOpen)}
                index={i}
                i={index}
                isOpen={isOpen}
                address={el?.first_name_pic}
                body={
                  <>
                    {isOpen === true && i === index ? (
                      <>
                        <div className="flex flex-col gap-[40px] ml-8">
                          {/* personal info */}
                          <div>
                            {/* <h3 className="font-roboto font-medium text-lg mb-6 mt-[30px]">
                              {t("Personal Info")}
                            </h3> */}
        <CustomDivider name={"Personal Info"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Position")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.position_pic ? el?.position_pic : "-"}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Last Name")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.last_name_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Birth Date")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.birth_date_pic ? dayjs(el?.birth_date_pic).format('DD MMMM YYYY') : "-"}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("ID Card/NIK")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.nik_pic}
                                  </h4>
                                </div>
                              </div>
                              {/* line two */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Title")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.title_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Gender")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.gender_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Phone Number")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.phone_number_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Tax Number")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.npwp_pic.replaceAll(/[.-]/g, "")}
                                  </h4>
                                </div>
                              </div>
                              {/* line three */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("First Name")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.first_name_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Birth Place")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.birth_place_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Email")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.email_pic}
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* address */}
                          <div>
                            {/* <h3 className="font-roboto font-medium text-lg mb-6 mt-[30px]">
                              {t("Depot Address")}
                            </h3> */}
        <CustomDivider name={"Depot Address"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Country")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.country_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Sub District")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.sub_district_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Hamlet")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.hamlet_pic ? el?.hamlet_pic : "-"}
                                  </h4>
                                </div>
                              </div>
                              {/* line two */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Province")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.province_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Urban Village")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.urban_village_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Postal Code")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.postal_code_pic}
                                  </h4>
                                </div>
                              </div>
                              {/* line three */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("District")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.district_pic}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Address")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.address_pic ? el?.address_pic : "-"}
                                  </h4>
                                </div>
                                <div className="w-[350px] mb-[24px]">
                                  <label className="font-roboto text-[14px] text-[#818181]">
                                    {t("Neighbourhood")}
                                  </label>
                                  <h4 className="font-roboto font-medium text-lg text-[#424242]">
                                    {el?.neighborhood_pic ? el?.neighborhood_pic : "-"}
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </>
                }
              />
            </div>
          );
        })}
      </>
    );
  };

  const formatTime = (time) => {
    const formattedTime = moment(time, "HH:mm:ss")
      .format("HH:mm")
      .toUpperCase();

    return formattedTime;
  };

  const OperationalHours = () => {
    return (
      <>
        {
          detail?.operational_time && detail?.operational_time.map((item, index) => {
            return (
              <div key={index} className=' flex flex-row mt-4'>
                <div className=' w-96'>
                  <LabelDetail children='Operational Day' />
                  <ValueDetail children={`${item?.operational_day} - ${item?.is_operational_active === "Y" ? 'Open' : 'Closed'}`} />
                </div>
                <div className=' w-96'>
                  <LabelDetail children='Operational Time' />
                  <ValueDetail children={`${item?.operational_start_time ? formatTime(item?.operational_start_time) : '-'} 
              - ${item?.operational_end_time ? formatTime(item?.operational_end_time) : '-'}`} />
                </div>
              </div>
            )
          })
        }
      </>
    );
  };
  const getUpdatedOperationalDate = (data) => {
    setUpdatedOperationalDate(data);
  };
  const OperationalDates = () => {
    return (
      <>
         <OperationalDate 
          data={updatedOperationalDate}
          updated={(data) => getUpdatedOperationalDate(data)}
          opsDate={opsDate ? opsDate : []} 
          setOperationalDateData={setOperationalDateData}/>
               </>
    ) };
  const items = [
    {
      key: 1,
      label: t("Depot Profile"),
      children: DepotProfile(),
    },
    {
      key: 2,
      label: t("System Preference"),
      children: SystemPreference(),
    },
    {
      key: 3,
      label: t("Person In Charge"),
      children: PersonInCharge(),
    },
    {
      key: 4,
      label: t("Operational Hours"),
      children: OperationalHours(),
    },
    {
      key: 5,
      label: t("Operational Date"),
      children: OperationalDates(),
    },
  ];

  return (
    <>
      <Delete
        data={detail.updated_at}
        id={detail.depot_profile?.depot_id}
        delete={showDelete}
        title={detail.depot_profile?.depot_name}
        url={"depot-configuration"}
        action={() => setShowDelete(false)}
        route={ROUTES.DEPOT_CONFIG.LIST}
        token={token}
        param={param}
      // refresh={fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Setup`}
          menuLevel2={`Depot Configuration`}
          menuLevel3={`Detail ${detail?.depot_profile?.depot_id} - ${detail?.depot_profile?.depot_name}`}
        />

        <div className="flex items-center justify-between">
          <div
            className="flex items-center gap-[22px] cursor-pointer"
            onClick={() => navigate(ROUTES.DEPOT_CONFIG.LIST)}
          >
            <img src={BackIcon} alt="" />
            <h1 className="font-sans-bold text-[28px]" id="title">
              Detail {detail?.depot_profile?.depot_id} -{" "}
              {detail?.depot_profile?.depot_name}
            </h1>
          </div>

          <div
            className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
            onClick={() => setUserManagementOpen(true)}
          >
            <p className="text-[#666666]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.created_at, true)}</strong> |{" "}
              {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
              <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.updated_at, true)}</strong>
            </p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
        </div>
        <div className="flex flex-row-reverse gap-[16px]">
          <PrimaryButton
            text={t("DRIVER:EDIT")}
            action={() =>
              navigate(ROUTES.DEPOT_CONFIG.EDIT, {
                state: detail.depot_profile?.depot_id,
              })
            }
          />
          <SecondaryButton
            text={t("DRIVER:DELETE")}
            action={() => setShowDelete(true)}
          />
        </div>
      </div>
      <aside
        className={
          userManagementOpen
            ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
            : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
        }
      >
        <button
          className="absolute top-[21px] right-[21px]"
          onClick={() => setUserManagementOpen(false)}
        >
          <img src={CloseIcon} alt="" />
        </button>

        <h3 className="font-sans font-[600] text-[#1D1D1D] text-[20px]">
          {t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}
        </h3>
        <p className="font-sans font-[400] text-[#818181] text-[12px] mb-[24px]">
          {t("USER_DETAIL:CREATED_BY")} <strong>{detail?.created_by}</strong>{" "}
          {t("USER_DETAIL:ON")}{" "}
          <strong>{convertTimestamp(detail?.created_at)}</strong>
        </p>

        <div className={style.timelineContainer}>
          <Timeline>
            {managementHistoryList.map((item, index) => {
              if (index === 0) {
                return (
                  <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                    <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                      <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>
                        {t("USER_DETAIL:LAST_MODIFIED")}
                      </h4>
                      <h4 className="font-[500] text-[14px] text-[#424242]">
                        {item.alias_name}
                      </h4>
                      <p className="font-[400] text-[14px]">{`${convertTimestamp(
                        item.created_at
                      )} • ${convertToTime(item.created_at)}`}</p>
                    </div>
                  </Timeline.Item>
                );
              } else {
                return (
                  <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                    <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                      <h4 className={"font-[500]"}>
                        {t("USER_DETAIL:MODIFIED")}
                      </h4>
                      <h4 className="font-[500] text-[14px] text-[#424242]">
                        {item.alias_name}
                      </h4>
                      <p className="font-[400] text-[14px]">{`${convertTimestamp(
                        item.created_at
                      )} • ${convertToTime(item.created_at)}`}</p>
                    </div>
                  </Timeline.Item>
                );
              }
            })}
          </Timeline>
        </div>
      </aside>
    </>
  );
};
export default DepotConfigDetail;
